import * as React from "react";
import { Table, Spin, BackTop, Tooltip, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";

export const GET_ORGS = gql`
  query getOrgs {
    organisation {
      uuid
      org_name
      tax_id
      address
    }
  }
`;

export default function Orgs(props) {
  const { data, loading, error } = useQuery(GET_ORGS, {
    fetchPolicy: "network-only"
  });
  const [count, setCount] = React.useState(null);

  const columns = [
    {
      title: "ID",
      key: "uuid",
      dataIndex: "uuid"
    },
    {
      title: "Name",
      key: "org_name",
      dataIndex: "org_name",
      sorter: (a, b) => a.org_name.localeCompare(b.org_name),
      sortDirections: ["ascend","descend"],
      defaultSortOrder: 'ascend'
    },
    {
      title: "GSTN/PAN",
      key: "tax_id",
      dataIndex: "tax_id"
    },
    {
      title: "Address",
      key: "address",
      render: record => <p>{record.address.line1}{" "}{record.address.line2}{" "}
      {record.address.city}{" "}{record.address.state}{" "}-{" "}
      {record.address.pincode}</p>
    },
    {
      title: "",
      key: "edit",
      render: record => {
        return ( 
          <Tooltip title="Edit organisation">
            <Button
              type="primary"
              className="bg-gray-600 hover:bg-gray-500 border-none"
              icon={<EditOutlined style={{verticalAlign: "middle"}}/>}
              shape="circle"
              onClick={() => props.history.push(`/edit-organisation/${record.uuid}`)}
            />
          </Tooltip>
        );
      }
    }
  ];

  if (loading) return <div className="center-div-on-screen"><Spin size="large"/></div>;

  if (error) console.log(error);

  return (
    <div className="p-8 mx-auto">
      <h2 className="text-xl text-center text-teal-700 mb-4">Organisations</h2>
      <div className="my-4 mx-auto overflow-x-auto text-gray-700">
        <Table 
          title={() => <div className="flex flex-row justify-between">
            <p className="text-left font-semibold">Showing {count === null ? data.organisation.length : count} Entries</p>
            <Button
              size="middle"
              type="primary"
              className="text-right bg-teal-500 hover:bg-teal-400 border-none"
              shape="round"
              onClick={() => props.history.push("/add-organisation")}
            >
              Add organisation
            </Button>
          </div>}
          dataSource={data.organisation} 
          columns={columns} 
          locale={{emptyText:"No organisations yet"}}
          rowKey={(record) => record.uuid}
          onChange={(pagination, filters, sorter, extra) => setCount(extra.currentDataSource.length)}/>
      </div>
      <BackTop />
    </div>
  );
}
